export default "__VITE_ASSET__C0aYz2Xj__"